export default "__VITE_ASSET__7191e7a7__"